import React from 'react'
import TextTemplate from './templates/TextTemplate'
import ImageTemplate from './templates/ImageTemplate'
import Intent from './intent'
import { IChatbotState } from '../../utils/interfaces/IChatbotState'
import { v4 as uuidv4 } from 'uuid'

interface IProps {
  chatRoomId: number
  type: 'Unassigned' | 'Assigned' | 'Resolved' | 'Chat-Report'
  previousValue: IChatbotState['previousValue']
  conversation: IChatbotState['conversation']
  flagMessageRead: any
  token?: IChatbotState['token']
  trigger?: (
    id: any,
    userInputValue?: string | undefined,
    fromAdmin?: boolean | undefined
  ) => Promise<void>
  onButtonClicked?: (nextIntentId: number, value: any, id: any, formdata: any) => void
  uploadFileUrl: string
  apiKey?: string
}

const IntentRenderer: React.FC<IProps> = ({
  chatRoomId,
  previousValue,
  conversation,
  type,
  flagMessageRead,
  uploadFileUrl,
  apiKey
}): any => {
  let conv = conversation?.slice(0)
  let lastRenderedDate: string | null = null

  return conv?.map((item, index) => {
    const messageTime = item?.time
    const dateObj = new Date(messageTime)
    const messageDate = dateObj.toDateString()

    const shouldRenderDate = messageDate !== lastRenderedDate
    if (shouldRenderDate) lastRenderedDate = messageDate

    // Get message depending on source
    let message = item?.MessageGroupId ? item?.data?.content?.message : item?.content?.message

    // Replace {previousValue:id} with actual value
    const regex = new RegExp('{previousValue:\\d+}', 'g')
    if (regex.test(message) && previousValue) {
      const matches = Array.from(message.match(regex) || [])
      matches.forEach((match:any) => {
        const prevId = parseInt(match.substring(1, match.length - 1).split(':')[1])
        const prevVal = previousValue.find((itemValue) => itemValue.id === prevId)
        if (prevVal) {
          message = message.replace(match, prevVal.value)
          if (item?.content) item.content.message = message
          else if (item?.data?.content) item.data.content.message = message
        }
      })
    }

    const side = item?.MessageGroupId ? item?.side : item?.content?.side

    return (
      <React.Fragment key={`fragment-${uuidv4()}`}>
        {shouldRenderDate && dateObj instanceof Date && !isNaN(dateObj.getTime()) && (
  <div className="d-flex justify-content-center mb-4">
    <div
      className="p-1 rounded bg-light text-dark fw-bold text-center"
      style={{ width: 'fit-content' }}
    >
      {new Intl.DateTimeFormat('en-IN', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        timeZone: 'Asia/Kolkata',
      }).format(dateObj)}
    </div>
  </div>
)}

        {item?.content?.human ? (
          <Intent
            type={type}
            chatRoomId={chatRoomId}
            side={side}
            key={`unique-key${uuidv4()}`}
            time={item?.time}
            item={item}
          >
            {TextTemplate({
              message: message,
              side: side,
              readByRecipientId: item?.readByRecipientId,
              uploadFileUrl: uploadFileUrl,
              apiKey: apiKey,
            })}
          </Intent>
        ) : item?.content?.metadata ? (
          item?.content?.metadata?.templateId === 11 ? (
            <Intent
              type={type}
              chatRoomId={chatRoomId}
              side={side}
              key={`unique-key${uuidv4()}`}
              time={item?.time}
              item={item}
            >
              {ImageTemplate({
                id: item?.content?.id,
                side: side,
                message: message,
                payload: item?.content?.metadata?.payload,
              })}
            </Intent>
          ) : (
            <Intent
              type={type}
              chatRoomId={chatRoomId}
              side={side}
              key={`unique-key${uuidv4()}`}
              time={item?.time}
              item={item}
            >
              {TextTemplate({
                message: message,
                side: side,
                readByRecipientId: item?.readByRecipientId,
                uploadFileUrl: uploadFileUrl,
                apiKey: apiKey,
              })}
            </Intent>
          )
        ) : (
          <Intent
            type={type}
            chatRoomId={chatRoomId}
            side={side}
            key={`unique-key${uuidv4()}`}
            time={item?.time}
            item={item}
          >
            {TextTemplate({
              message: message,
              side: side,
              readByRecipientId: item?.readByRecipientId,
              uploadFileUrl: uploadFileUrl,
              apiKey: apiKey,
            })}
          </Intent>
        )}
      </React.Fragment>
    )
  })
}

export default IntentRenderer